import { render, staticRenderFns } from "./author-add.vue?vue&type=template&id=3753d598&scoped=true&"
import script from "./author-add.vue?vue&type=script&lang=js&"
export * from "./author-add.vue?vue&type=script&lang=js&"
import style0 from "./author-add.vue?vue&type=style&index=0&id=3753d598&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3753d598",
  null
  
)

export default component.exports